export interface Steps {
  step: number;
  route: string;
  noService?: boolean;
}

export const stripeVerifiedStatuses = ["SUCCESS", "verified"];
export const editableStatuses = ["PENDING", "IN_PROGRESS"];
export const pdfEditionStatuses = ["lock", "edit", "delete"];
